import TableSearch from "@rio-cloud/rio-uikit/TableSearch";
import { useT } from "@hooks";

interface Props {
  searchValue: string;
  handleSearchValueChange: (newSearchValue: string) => void;
}

const ToolbarSearch = ({ searchValue, handleSearchValueChange }: Props) => {
  const t = useT();

  return (
    <div className="width-100pct-xs">
      <TableSearch
        className="rounded-small width-100pct-xs width-250 width-300-sm"
        value={searchValue}
        onChange={handleSearchValueChange}
        placeholder={t("common.label.search")}
      />
    </div>
  );
};

export default ToolbarSearch;
